import { reactive } from 'vue';

const auth = reactive({
  usuario: JSON.parse(localStorage.getItem('usuario')) || null,
  login(usuario) {
    this.usuario = usuario;
    localStorage.setItem('usuario', JSON.stringify(usuario));
  },
  logout() {
    this.usuario = null;
    localStorage.removeItem('usuario');
  }
});

export default auth;